import { setToken } from "./api";
export default {
  registerToken(data) {
    localStorage.setItem("ff_token", data.token);
    localStorage.setItem("ff_userId", data.user.id);
    setToken(data.token);
  },
};
